import type { State } from './types';

export const initialState: State = {
  isEnabled: false,
  isInitialized: false,
};
